import { createFeatureSelector, createSelector } from '@ngrx/store';
import { BattleState } from './reducer';

export const selectBattle = createFeatureSelector<BattleState>('Battle');
